module.exports = __webpack_public_path__ + "static/media/Sol Amour.85623234.png";